/* global $ */
/* global _ */
/* global moment */
/* global angular */
(function (module) {
  "use strict";
  module
    .config([
      "$compileProvider",
      "$stateProvider",
      "$urlRouterProvider",
      "$qProvider",
      "toastrConfig",
      "ngIntlTelInputProvider",
      function (
        $compileProvider,
        $stateProvider,
        $urlRouterProvider,
        $qProvider,
        toastrConfig,
        ngIntlTelInputProvider
      ) {
        $compileProvider.preAssignBindingsEnabled(true);
        angular.extend(toastrConfig, {
          autoDismiss: false,
          containerId: "toast-container",
          maxOpened: 0,
          newestOnTop: true,
          positionClass: "toast-top-left",
          preventDuplicates: false,
          preventOpenDuplicates: false,
          target: "body",
        });

        $qProvider.errorOnUnhandledRejections(false);

        $urlRouterProvider.otherwise("/");

        $stateProvider
          .state("closepage", {
            url: "/close",
            templateUrl: "closepage.html",
          })
          .state("login", {
            url: "/login",
            templateUrl: "login.html",
          })
          .state("signup", {
            url: "/signup",
            templateUrl: "signup.html",
          })
          .state("activate", {
            url: "/activate/{guid}",
            templateUrl: "activate.html",
          })
          .state("resetpassword", {
            url: "/resetpassword/{guid}",
            templateUrl: "activate.html",
          })
          .state("forgot", {
            url: "/forgot",
            templateUrl: "forgot.html",
          })
          .state("logout", {
            url: "/logout",
            controller: "LogoutCtrl",
          })
          .state("app", {
            url: "/",
            views: {
              "@": {
                templateUrl: "layout.html",
                controller: "IndexCtrl",
              },
              "topBar@app": {
                templateUrl: "/templates/partials/topBar.html",
              },
              "sideBar@app": {
                templateUrl: "/templates/partials/sideBar.html",
              },
              "chatForm@app": {
                templateUrl: "/templates/partials/chatForm.html",
              },
              "breadCrumb@app": {
                templateUrl: "/templates/partials/breadCrumb.html",
              },
              "content@app": {
                templateUrl: "/templates/partials/tripsDashboard.html",
                controller: "tripsDashBoardController",
              },
              "footer@app": {
                templateUrl: "/templates/partials/footer.html",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: [
              "ObexAdmin",
              "TravelManager",
              "TravelAgencyAdmin",
              "TravelAgent",
            ],
            data: {
              pageTitle: "Home",
            },
          })
          .state("app.dashboard", {
            url: "dashboard",
            views: {
              "content@app": {
                templateUrl: "/templates/partials/tripsDashboard.html",
                controller: "tripsDashBoardController",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: [
              "ObexAdmin",
              "TravelManager",
              "TravelAgencyAdmin",
              "TravelAgent",
            ],
            data: {
              pageTitle: "Trips Dashboard",
            },
          })
          .state("app.viewTripDetails", {
            url: "viewTripDetails",
            params: {
              id: null,
            },
            views: {
              "content@app": {
                templateUrl: "templates/partials/viewTripDetails.html",
                controller: "TripsDashBoardController",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: ["ObexAdmin", "TravelManager"],
            data: {
              pageTitle: "Booking Details",
            },
          })
          .state("app.travelSpend", {
            url: "travelSpend",
            views: {
              "content@app": {
                templateUrl: "templates/partials/travelSpend.html",
                controller: "travelSpendController",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: [
              "ObexAdmin",
              "TravelManager",
              "TravelAgencyAdmin",
            ],
            data: {
              pageTitle: "Travel Spend",
            },
          })
          .state("app.travelerTrack", {
            url: "travelerTrack",
            views: {
              "content@app": {
                templateUrl: "templates/partials/travelerTrack.html",
                controller: "travelerTrackController",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: [
              "ObexAdmin",
              "TravelManager",
              "TravelAgencyAdmin",
              "TravelAgent",
            ],
            data: {
              pageTitle: "Traveler Track",
            },
          })
          .state("app.clientManagement", {
            url: "clients",
            views: {
              "content@app": {
                templateUrl: "templates/partials/clientManagement.html",
                controller: "clientManagementController",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: [
              "ObexAdmin",
              "TravelAgencyAdmin",
              "TravelAgent",
              "TravelManager",
            ],
            data: {
              pageTitle: "Clients",
            },
          })
          .state("app.agencyManagement", {
            url: "agencyManagement",
            views: {
              "content@app": {
                templateUrl: "templates/partials/agencyManagement.html",
                controller: "agencyManagementController",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: ["ObexAdmin", "TravelAgencyAdmin"],
            data: {
              pageTitle: "Agency Management",
            },
          })
          .state("app.addAgency", {
            url: "agency/add",
            views: {
              "content@app": {
                templateUrl: "templates/partials/addAgency.html",
                controller: "agencyManagementController",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: ["ObexAdmin", "TravelAgencyAdmin"],
            data: {
              pageTitle: "Add Agency",
            },
          })
          .state("app.editAgency", {
            url: "agency/edit",
            params: {
              id: null,
            },
            views: {
              "content@app": {
                templateUrl: "templates/partials/addAgency.html",
                controller: "agencyManagementController",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: ["ObexAdmin", "TravelAgencyAdmin"],
            data: {
              pageTitle: "Edit Agency",
            },
          })
          .state("app.agents", {
            url: "agents",
            views: {
              "content@app": {
                templateUrl: "templates/partials/agents.html",
                controller: "membersController",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: ["ObexAdmin", "TravelAgencyAdmin"],
            data: {
              pageTitle: "Agents",
            },
          })
          .state("app.addAgent", {
            url: "agent/add",
            params: {
              id: null,
            },
            views: {
              "content@app": {
                templateUrl: "templates/partials/addAgent.html",
                controller: "membersController",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: ["ObexAdmin", "TravelAgencyAdmin"],
            data: {
              pageTitle: "Add Agent",
            },
          })
          .state("app.editAgent", {
            url: "agent/edit",
            params: {
              id: null,
            },
            views: {
              "content@app": {
                templateUrl: "templates/partials/editAgent.html",
                controller: "membersController",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: ["ObexAdmin", "TravelAgencyAdmin"],
            data: {
              pageTitle: "Edit Agent",
            },
          })
          .state("app.gdsSettings", {
            url: "gdsSettings",
            views: {
              "content@app": {
                templateUrl: "templates/partials/gdsSettings.html",
                controller: "gdsSettingsController",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: ["ObexAdmin"],
            data: {
              pageTitle: "Gds Settings",
            },
          })
          .state("app.addGdsSetting", {
            url: "gdsSetting/add",
            params: {
              id: null,
            },
            views: {
              "content@app": {
                templateUrl: "templates/partials/addGdsSetting.html",
                controller: "gdsSettingsController",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: ["ObexAdmin"],
            data: {
              pageTitle: "Add Gds Setting",
            },
          })
          .state("app.editGdsSetting", {
            url: "gdsSetting/edit",
            params: {
              id: null,
            },
            views: {
              "content@app": {
                templateUrl: "templates/partials/editGdsSetting.html",
                controller: "gdsSettingsController",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: ["ObexAdmin"],
            data: {
              pageTitle: "Edit Gds Setting",
            },
          })
          .state("app.changePassword", {
            url: "changepassword",
            views: {
              "content@app": {
                templateUrl: "templates/partials/changepassword.html",
                controller: "passwordController",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: [
              "ObexAdmin",
              "TravelManager",
              "TravelAgencyAdmin",
              "TravelAgent",
            ],
            data: {
              pageTitle: "Change Your Password",
            },
          })
          .state("app.sms-notif", {
            url: "live",
            views: {
              "content@app": {
                templateUrl: "templates/partials/smsNotification.html",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: ["TravelAgencyAdmin", "TravelAgent"],
            data: {
              pageTitle: "Live",
            },
            params: {
              status: null,
            },
          })
          /*.state('app.phone-notif', {
            url: 'phonenotif',
            views: {
              'content@app': {
                templateUrl: 'templates/partials/phoneNotification.html',
                controller: 'SmsNotificationController'
              }
            },
            requiresAuthentication: true,
            allowedPermissions: ['TravelAgencyAdmin', 'TravelAgent'],
            data: {
              pageTitle: 'Phone Notifications'
            }
          })*/
          .state("app.sms", {
            url: "sms",
            views: {
              "content@app": {
                templateUrl: "templates/partials/sms.html",
              },
            },
            onEnter: [
              "alertService",
              function (alert) {
                console.log("onEnter app.sms");
              },
            ],
            requiresAuthentication: true,
            allowedPermissions: [
              "ObexAdmin",
              "TravelAgencyAdmin",
              "TravelAgent",
            ],
            data: {
              pageTitle: "Sms",
            },
            params: {
              fromNumber: null,
              travelerFirstName: null,
              travelerLastName: null,
              travelerOrganizationName: null,
              organizationId: null,
              travelerId: null,
              topic: null,
              status: null,
              conversation: null,
              fromDatabase: null,
              channel: null,
            },
          })
          .state("app.followup", {
            url: "followup",
            views: {
              "content@app": {
                templateUrl: "templates/partials/sms.html",
              },
            },
            onEnter: [
              "alertService",
              function (alert) {
                console.log("onEnter app.followup");
              },
            ],
            requiresAuthentication: true,
            allowedPermissions: [
              "ObexAdmin",
              "TravelAgencyAdmin",
              "TravelAgent",
            ],
            data: {
              pageTitle: "On-Hold",
            },
            params: {
              fromNumber: null,
              travelerFirstName: null,
              travelerLastName: null,
              travelerOrganizationName: null,
              organizationId: null,
              travelerId: null,
              topic: null,
              status: null,
              conversation: null,
              fromDatabase: null,
              channel: null,
            },
          })
          .state("app.smsHistory", {
            url: "smsHistory",
            views: {
              "content@app": {
                templateUrl: "templates/partials/smsHistory.html",
                controller: "smsHistoryController",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: [
              "ObexAdmin",
              "TravelAgencyAdmin",
              "TravelAgent",
            ],
            data: {
              pageTitle: "SMS History",
            },
          })
          /*.state('app.phoneHistory', {
            url: 'phoneHistory',
            views: {
              'content@app': {
                templateUrl: 'templates/partials/phoneHistory.html',
                controller: 'phoneHistoryController'
              }
            },
            requiresAuthentication: true,
            allowedPermissions: ['ObexAdmin', 'TravelAgencyAdmin', 'TravelAgent'],
            data: {
              pageTitle: 'Phone History'
            }
          })*/
          .state("app.phone", {
            url: "Phone",
            views: {
              "content@app": {
                templateUrl: "templates/partials/phone.html",
              },
            },
            onEnter: [
              "alertService",
              function (alert) {
                console.log("onEnter app.phone");
              },
            ],

            requiresAuthentication: true,
            allowedPermissions: [
              "ObexAdmin",
              "TravelAgencyAdmin",
              "TravelAgent",
            ],
            data: {
              pageTitle: "Phone",
            },
            params: {
              fromNumber: null,
              travelerFirstName: null,
              travelerLastName: null,
              travelerOrganizationName: null,
              travelerId: null,
              topic: null,
            },
          })
          .state("app.addClient", {
            url: "client/add",
            views: {
              "content@app": {
                templateUrl: "templates/partials/addClient.html",
                controller: "clientManagementController",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: ["ObexAdmin", "TravelAgencyAdmin"],
            data: {
              pageTitle: "Add Client",
            },
          })
          .state("app.editClient", {
            url: "client/edit",
            params: {
              id: null,
            },
            views: {
              "content@app": {
                templateUrl: "templates/partials/addClient.html",
                controller: "clientManagementController",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: [
              "ObexAdmin",
              "TravelAgencyAdmin",
              "TravelManager",
            ],
            data: {
              pageTitle: "Edit Client",
            },
          })
          .state("app.tripField", {
            url: "tripFields",
            views: {
              "content@app": {
                templateUrl: "templates/partials/tripFields.html",
                controller: "tripFieldsController",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: [
              "TravelAgencyAdmin",
              "TravelManager",
              "ObexAdmin",
              "TravelAgent",
            ],
            data: {
              pageTitle: "Trip Fields",
            },
          })
          .state("app.addTripField", {
            url: "tripField/add",
            views: {
              "content@app": {
                templateUrl: "templates/partials/addTripField.html",
                controller: "tripFieldsController",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: [
              "TravelAgencyAdmin",
              "TravelManager",
              "ObexAdmin",
              "TravelAgent",
            ],
            data: {
              pageTitle: "Add Trip Field",
            },
          })
          .state("app.editTripField", {
            url: "tripField/edit",
            params: {
              id: null,
              orgId: null,
            },
            views: {
              "content@app": {
                templateUrl: "templates/partials/addTripField.html",
                controller: "tripFieldsController",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: [
              "TravelAgencyAdmin",
              "TravelManager",
              "ObexAdmin",
              "TravelAgent",
            ],
            data: {
              pageTitle: "Edit Trip Field",
            },
          })
          .state("app.profileField", {
            url: "profileFields",
            views: {
              "content@app": {
                templateUrl: "templates/partials/profileFields.html",
                controller: "profileFieldsController",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: [
              "ObexAdmin",
              "TravelManager",
              "TravelAgencyAdmin",
              "TravelAgent",
            ],
            data: {
              pageTitle: "Profile Fields",
            },
          })
          .state("app.addProfileField", {
            url: "profileFields/add",
            views: {
              "content@app": {
                templateUrl: "templates/partials/addProfileField.html",
                controller: "profileFieldsController",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: [
              "ObexAdmin",
              "TravelManager",
              "TravelAgencyAdmin",
              "TravelAgent",
            ],
            data: {
              pageTitle: "Add Profile Field",
            },
          })
          .state("app.editProfileField", {
            url: "profileFields/edit",
            views: {
              "content@app": {
                templateUrl: "templates/partials/editProfileField.html",
                controller: "profileFieldsController",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: [
              "ObexAdmin",
              "TravelManager",
              "TravelAgencyAdmin",
              "TravelAgent",
            ],
            data: {
              pageTitle: "Edit Profile Field",
            },
          })
          .state("app.customerAccountNumbers", {
            url: "customeraccountnumbers",
            views: {
              "content@app": {
                templateUrl: "templates/partials/customerAccountNumbers.html",
                controller: "customerAccountController",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: [
              "ObexAdmin",
              "TravelAgencyAdmin",
              "TravelManager",
              "TravelAgent",
            ],
            data: {
              pageTitle: "Customer Account Numbers",
            },
          })
          .state("app.addCustomerAccoNum", {
            url: "addcustomeraccountnumbers",
            views: {
              "content@app": {
                templateUrl: "templates/partials/addCustomerAccoNum.html",
                controller: "customerAccountController",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: [
              "ObexAdmin",
              "TravelAgencyAdmin",
              "TravelManager",
              "TravelAgent",
            ],
            data: {
              pageTitle: "Add Customer Account Number",
            },
          })
          .state("app.editCustomerAccoNum", {
            url: "editcustomeraccountnumbers",
            params: {
              id: null,
            },
            views: {
              "content@app": {
                templateUrl: "templates/partials/addCustomerAccoNum.html",
                controller: "customerAccountController",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: [
              "ObexAdmin",
              "TravelAgencyAdmin",
              "TravelManager",
              "TravelAgent",
            ],
            data: {
              pageTitle: "Edit Customer Account Number",
            },
          })
          .state("app.clientSettings", {
            url: "client/clientsettings",
            views: {
              "content@app": {
                templateUrl: "templates/partials/clientSettings.html",
                controller: "clientSettingController",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: ["ObexAdmin", "TravelAgencyAdmin"],
            data: {
              pageTitle: "Client's My Agency",
            },
          })
          .state("app.singleSignOn", {
            url: "client/singleSignOn",
            views: {
              "content@app": {
                templateUrl: "templates/partials/singleSignOn.html",
                controller: "singleSignOnController",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: ["ObexAdmin"],
            data: {
              pageTitle: "Single Sign On",
            },
          })
          .state("app.ssoOrganizations", {
            url: "client/ssoOrganizations",
            views: {
              "content@app": {
                templateUrl: "templates/partials/ssoOrganizations.html",
                controller: "ssoOrganizationsController",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: ["ObexAdmin"],
            data: {
              pageTitle: "SSO Organization",
            },
          })
          .state("app.addSsoOrganization", {
            url: "addSsoOrganization",
            views: {
              "content@app": {
                templateUrl: "templates/partials/addSsoOrganization.html",
                controller: "ssoOrganizationsController",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: ["ObexAdmin"],
            data: {
              pageTitle: "Add SSO Organization",
            },
          })
          .state("app.editSsoOrganization", {
            url: "editSsoOrganization",
            params: {
              id: null,
            },
            views: {
              "content@app": {
                templateUrl: "templates/partials/addSsoOrganization.html",
                controller: "ssoOrganizationsController",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: ["ObexAdmin"],
            data: {
              pageTitle: "Edit SSO Organization",
            },
          })
          .state("app.travelers", {
            url: "traveler",
            views: {
              "content@app": {
                templateUrl: "templates/partials/traveler.html",
                controller: "travelerController",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: [
              "ObexAdmin",
              "TravelAgencyAdmin",
              "TravelManager",
              "TravelAgent",
            ],
            data: {
              pageTitle: "Employees/Travelers",
            },
          })
          .state("app.addTraveler", {
            url: "addTraveler",
            views: {
              "content@app": {
                templateUrl: "templates/partials/addTraveler.html",
                controller: "travelerController",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: [
              "ObexAdmin",
              "TravelAgencyAdmin",
              "TravelManager",
              "TravelAgent",
            ],
            data: {
              pageTitle: "Add Traveler",
            },
          })
          .state("app.uploadHrFile", {
            url: "uploadHrFile",
            views: {
              "content@app": {
                templateUrl: "templates/partials/uploadHrFile.html",
                controller: "travelerController",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: ["ObexAdmin"],
            data: {
              pageTitle: "Upload HR File",
            },
          })
          .state("app.editTraveler", {
            url: "editTraveler",
            params: {
              id: null,
            },
            views: {
              "content@app": {
                templateUrl: "templates/partials/editTraveler.html",
                controller: "travelerController",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: [
              "ObexAdmin",
              "TravelAgencyAdmin",
              "TravelManager",
              "TravelAgent",
            ],
            data: {
              pageTitle: "Edit Traveler",
            },
          })
          .state("app.processPnr", {
            url: "processPnr",
            views: {
              "content@app": {
                templateUrl: "templates/partials/processPnr.html",
                controller: "pnrController",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: ["ObexAdmin", "TravelAgencyAdmin"],
            data: {
              pageTitle: "Process PNR",
            },
          })
          .state("app.providers", {
            url: "admin/providers",
            views: {
              "content@app": {
                templateUrl: "templates/partials/provider.html",
                controller: "providerController",
                permissions: ["ObexAdmin"],
              },
            },
            requiresAuthentication: true,
            allowedPermissions: ["ObexAdmin"],
            data: {
              pageTitle: "Providers",
            },
          })
          .state("app.addProvider", {
            url: "admin/providers/add",
            views: {
              "content@app": {
                templateUrl: "templates/partials/addProvider.html",
                controller: "providerController",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: ["ObexAdmin"],
            data: {
              pageTitle: "Add Provider",
            },
          })
          .state("app.editProvider", {
            url: "admin/providers/edit",
            params: {
              id: null,
            },
            views: {
              "content@app": {
                templateUrl: "templates/partials/addProvider.html",
                controller: "providerController",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: ["ObexAdmin"],
            data: {
              pageTitle: "Edit Provider",
            },
          })
          .state("app.categories", {
            url: "admin/categories",
            views: {
              "content@app": {
                templateUrl: "templates/partials/categories.html",
                controller: "categoriesController",
                permissions: ["ObexAdmin"],
              },
            },
            requiresAuthentication: true,
            allowedPermissions: ["ObexAdmin"],
            data: {
              pageTitle: "Categories",
            },
          })
          .state("app.addCategory", {
            url: "admin/categories/add",
            views: {
              "content@app": {
                templateUrl: "templates/partials/addCategory.html",
                controller: "categoriesController",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: ["ObexAdmin"],
            data: {
              pageTitle: "Add Category",
            },
          })
          .state("app.editCategory", {
            url: "admin/categories/edit",
            params: {
              id: null,
            },
            views: {
              "content@app": {
                templateUrl: "templates/partials/addCategory.html",
                controller: "categoriesController",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: ["ObexAdmin"],
            data: {
              pageTitle: "Edit Category",
            },
          })
          .state("app.apps", {
            url: "admin/apps",
            views: {
              "content@app": {
                templateUrl: "templates/partials/apps.html",
                controller: "appsController",
                permissions: ["ObexAdmin"],
              },
            },
            requiresAuthentication: true,
            allowedPermissions: ["ObexAdmin"],
            data: {
              pageTitle: "Apps",
            },
          })
          .state("app.addApp", {
            url: "admin/apps/add",
            views: {
              "content@app": {
                templateUrl: "templates/partials/addApp.html",
                controller: "appsController",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: ["ObexAdmin"],
            data: {
              pageTitle: "Add App",
            },
          })
          .state("app.editApp", {
            url: "admin/apps/edit",
            params: {
              id: null,
            },
            views: {
              "content@app": {
                templateUrl: "templates/partials/addApp.html",
                controller: "appsController",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: ["ObexAdmin"],
            data: {
              pageTitle: "Edit App",
            },
          })
          .state("app.reports", {
            url: "reports",
            views: {
              "content@app": {
                templateUrl: "templates/partials/reports.html",
                controller: "reportController",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: [
              "ObexAdmin",
              "TravelManager",
              "TravelAgencyAdmin",
            ],
            data: {
              pageTitle: "Reports",
            },
          })
          .state("app.myAgency", {
            url: "myAgency",
            views: {
              "content@app": {
                templateUrl: "templates/partials/myAgency.html",
                controller: "myAgencyController",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: ["TravelManager"],
            data: {
              pageTitle: "My Agency",
            },
          })
          .state("app.agentAssignment", {
            url: "agentAssignments",
            views: {
              "content@app": {
                templateUrl: "templates/partials/agentAssignment.html",
                controller: "agentAssignmentController",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: ["ObexAdmin", "TravelAgencyAdmin"],
            data: {
              pageTitle: "Agent Assignments",
            },
          })
          /*.state('app.travelManagerAssignment', {
            url: 'travelManagerAssignments',
            views: {
              'content@app': {
                templateUrl: 'templates/partials/travelManagerAssignment.html',
                controller: 'travelManagerAssignmentController'
              }
            },
            requiresAuthentication: true,
            allowedPermissions: ['ObexAdmin', 'TravelAgencyAdmin'],
            data: {
              pageTitle: 'Travel Manager Assignments'
            }
          })*/
          .state("app.agencySettings", {
            url: "agencySettings",
            views: {
              "content@app": {
                templateUrl: "templates/partials/agencySettings.html",
                controller: "agencySettingsController",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: ["ObexAdmin", "TravelAgencyAdmin"],
            data: {
              pageTitle: "Agency Defaults",
            },
          })
          .state("app.hrFeed", {
            url: "hrFeed",
            views: {
              "content@app": {
                templateUrl: "templates/partials/hrFeed.html",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: [
              "ObexAdmin",
              "TravelAgencyAdmin",
              "TravelManager",
              "TravelAgent",
            ],
            data: {
              pageTitle: "HR Feed",
            },
          })
          .state("app.organizationProviders", {
            url: "organizationProviders",
            views: {
              "content@app": {
                templateUrl: "templates/partials/organizationProviders.html",
                controller: "organizationProvidersController",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: [
              "ObexAdmin",
              "TravelAgencyAdmin",
              "TravelManager",
            ],
            data: {
              pageTitle: "My Providers",
            },
          })
          .state("app.allowIntegrations", {
            url: "allowIntegrations",
            views: {
              "content@app": {
                templateUrl: "templates/partials/allowIntegrations.html",
                controller: "allowIntegrationsController",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: [
              "ObexAdmin",
              "TravelAgencyAdmin",
              "TravelAgent",
              "TravelManager",
            ],
            data: {
              pageTitle: "Allow Integration",
            },
          })
          .state("app.addAllowIntegration", {
            url: "allowIntegrations/add",
            views: {
              "content@app": {
                templateUrl: "templates/partials/addAllowIntegration.html",
                controller: "allowIntegrationsController",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: ["ObexAdmin"],
            data: {
              pageTitle: "Add Allow Integration",
            },
          })
          .state("app.editAllowIntegration", {
            url: "allowIntegrations/edit",
            params: {
              id: null,
            },
            views: {
              "content@app": {
                templateUrl: "templates/partials/addAllowIntegration.html",
                controller: "allowIntegrationsController",
              },
            },
            requiresAuthentication: true,
            allowedPermissions: [
              "TravelAgencyAdmin",
              "ObexAdmin",
              "TravelManager",
            ],
            data: {
              pageTitle: "Edit Allow Integration",
            },
          })
          .state("travelprogram", {});
        ngIntlTelInputProvider.set({
          defaultCountry: "us",
          utilsScript: "helpers/intl-tel-input/build/js/utils.js",
        });
      },
    ])
    .run([
      "$rootScope",
      "$state",
      "$stateParams",
      "authService",
      "Carousel",
      function ($rootScope, $state, $stateParams, authService, Carousel) {
        $rootScope.$state = $state;
        $rootScope.$stateParams = $stateParams;
        $rootScope.$on(
          "$stateChangeStart",
          function (event, toState, toParams, fromState, fromParams) {
            if (
              toState.requiresAuthentication &&
              !authService.isAuthenticated()
            ) {
              event.preventDefault();
              $state.go("login");
            } else if (
              toState.requiresAuthentication &&
              authService.isAuthenticated()
            ) {
              const permissions = toState.allowedPermissions;
              if (!authService.userHasPermission(permissions)) {
                event.preventDefault();
              }
            }
          }
        );

        /*
        Carousel.setOptions({
          arrows: true,
          autoplay: false,
          autoplaySpeed: 3000,
          cssEase: 'ease',
          dots: false,
      
          easing: 'linear',
          fade: false,
          infinite: true,
          initialSlide: 0,
      
          slidesToShow: 1,
          slidesToScroll: 1,
          speed: 500,
        });*/

        window.setInterval(function () {
          $(".alert").not(".no-fade-alert").addClass("fade out");
        }, 10000);
        // BEGIN BACK TO TOP
        $(window).scroll(function () {
          if ($(this).scrollTop() < 200) {
            $("#totop").fadeOut();
          } else {
            $("#totop").fadeIn();
          }
        });
        $rootScope.scrollToTop = function () {
          $("html, body").animate(
            {
              scrollTop: 0,
            },
            "fast"
          );
          return false;
        };
        window.onbeforeunload = function () {
          console.log("state ", $state);
          if (
            $state.$current.path["0"].url.sourcePath !== "/login" &&
            $state.$current.path["0"].url.sourcePath !== "/signup" &&
            !$state.$current.path["0"].url.sourcePath.includes("/activate/") &&
            !$state.$current.path["0"].url.sourcePath.includes(
              "/resetpassword/"
            )
          ) {
            return "Please consider NOT reloading/refreshing the page.  Your conversation will be archived and you will no longer be able to assist the traveler";
          }
        };
        // END BACK TO TOP
      },
    ])
    .controller("IndexCtrl", function () {})
    .controller("LogoutCtrl", [
      "$state",
      "authService",
      "socket",
      "socketLogin",
      function ($state, authService, socket, socketLogin) {
        socket.sendClientDisconnect(
          socketLogin.getSocketId(),
          socketLogin.getLoginMember()
        );
        authService.clear();
        $state.go("login");
      },
    ]);
})(
  angular.module("obex", [
    "ui.router",
    "ngProgress",
    "ngDialog",
    "ngAnimate",
    "ngAria",
    "ngMaterial",
    "ngMessages",
    "mdPickers",
    "toastr",
    "ui.grid",
    "ui.grid.pagination",
    "ui.grid.selection",
    "ngSanitize",
    "permission",
    "ui.grid.resizeColumns",
    "angularResizable",
    "ngCsv",
    "ui.grid.treeView",
    "ui.grid.autoResize",
    "ui.grid.exporter",
    "ui.bootstrap",
    "angularRipple",
    "angular-intro",
    "ngIntlTelInput",
    "ui.carousel",
    "ngFileUpload",
  ])
);



// WEBPACK FOOTER //
// ./client/js/app.js